<template>
    <div class="dashboard">
        <template>
            <el-card style='padding:0px 5px 10px 5px' v-loading="rowLoading">
                <div style='width:49%;padding-right:1%;float:left;border-right:1px dashed #ccc;'>
                    <el-row :gutter="5" type="flex" justify="space-between">
                        <el-col :span="12" v-for="(item, index) in topCards.slice(0, 3)" :key="index">
                            <div class="card-container">
                                <el-card class="top-card">
                                    <div class="card-content">
                                        <i   :class="getIconClass(item.title)" class="icon"  ></i>
                                        <div v-if="item.title !== '日转化率'" class="text-content iconJump">
                                            <div class="card-value" v-animate-number="item.value"></div>
                                            <div class="card-title">{{ item.title }}</div>
                                        </div>
                                        <div v-else class="text-content iconJump">
                                            <div class="card-value" v-animate-number:2="item.value"></div>
                                            <div class="card-title">{{ item.title }}</div>
                                        </div>
                                    </div>
                                </el-card>
                                <div class="hover-layer"></div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div style='width:49%;float:right;' >
                    <el-row :gutter="5" type="flex" justify="space-between">
                        <el-col :span="12" v-for="(item, index) in topCards.slice(3, 6)" :key="index">
                            <div class="card-container">
                                <el-card class="top-card">
                                    <div class="card-content">
                                        <i   :class="getIconClass(item.title)" class="icon"  ></i>
                                        <div v-if="item.title !== '日转化率'" class="text-content iconJump">
                                            <div class="card-value" v-animate-number="item.value"></div>
                                            <div class="card-title">{{ item.title }}</div>
                                        </div>
                                        <div v-else class="text-content iconJump">
                                            <div class="card-value" v-animate-number:2="item.value"></div>
                                            <div class="card-title">{{ item.title }}</div>
                                        </div>
                                    </div>
                                </el-card>
                                <div class="hover-layer"></div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div style='clear:both'></div>
                <div style='width:49%;padding-right:1%;float:left;border-right:1px dashed #ccc;'>
                    <el-row :gutter="5" type="flex" justify="space-between">
                        <el-col :span="12" v-for="(item, index) in topCards.slice(6, 9)" :key="index">
                            <div class="card-container">
                                <el-card class="top-card">
                                    <div class="card-content">
                                        <i   :class="getIconClass(item.title)" class="icon"  ></i>
                                        <div v-if="item.title !== '日转化率'" class="text-content iconJump">
                                            <div class="card-value" v-animate-number="item.value"></div>
                                            <div class="card-title">{{ item.title }}</div>
                                        </div>
                                        <div v-else class="text-content iconJump">
                                            <div class="card-value" v-animate-number:2="item.value"></div>
                                            <div class="card-title">{{ item.title }}</div>
                                        </div>
                                    </div>
                                </el-card>
                                <div class="hover-layer"></div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div style='width:49%;float:right;' >
                    <el-row :gutter="5" type="flex" justify="space-between">
                        <el-col :span="12" v-for="(item, index) in topCards.slice(9, 12)" :key="index">
                            <div class="card-container">
                                <el-card class="top-card">
                                    <div class="card-content">
                                        <i   :class="getIconClass(item.title)" class="icon"  ></i>
                                        <div v-if="item.title !== '日转化率'" class="text-content iconJump">
                                            <div class="card-value" v-animate-number="item.value"></div>
                                            <div class="card-title">{{ item.title }}</div>
                                        </div>
                                        <div v-else class="text-content iconJump">
                                            <div class="card-value" v-animate-number:2="item.value"></div>
                                            <div class="card-title">{{ item.title }}</div>
                                        </div>
                                    </div>
                                </el-card>
                                <div class="hover-layer"></div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-card>
        </template>

<div class="chart-rows">
        <el-row v-loading="schartLoading" :gutter="2" style="margin-top: 2px;">
            <el-col :span="12" class='mt5'>
                <el-card>
                    <div :style="{ height: chartHeight + 'px' }" id="echart1" class="echartswh"></div>
                    <div :style="{ height: chartHeight + 'px' }" id="echart3" class="echartswh"></div>
                    <div :style="{ height: chartHeight + 'px' }" id="echart5" class="echartswh"></div>
                </el-card>
            </el-col>
            <el-col :span="12"  class='mt5'>
                <el-card>
                    <div :style="{ height: chartHeight + 'px' }" id="echart2" class="echartswh"></div>
                    <div :style="{ height: chartHeight + 'px' }" id="echart4" class="echartswh"></div>
                    <div :style="{ height: chartHeight + 'px' }" id="echart6" class="echartswh"></div>
                </el-card>
            </el-col>
        </el-row>
 
         </div>
    </div>
</template>

<script>
import {
    findOrderStatistics,
    dataStatistics30,
    findDataByTodayAndThisMonth,
    findDataByDataBody5,
    findEchartByDataBody5
} from '../../../api/orderStatistics/orderStatustucs';
import * as echarts from 'echarts';

export default {
    name: 'charts',
    data() {
        return {
            rowLoading: false,
            schartLoading: false,
            schartLoading1: false,
            channelLoading: false,
            productLoading: false,
            lastTotalAvg: 0,
            query: { dataType: '1' },
            refreshProgress: 100, // 初始进度为100%
            refreshCountdown: 10, // 初始倒计时为10秒
            refreshInterval: null,// 存储定时器ID
            chartHeight :145,
            orderNum: {
                total: 0,
                success: 0,
                overallAverageConversion: 0,
                lastMonthSuccessOrder: 0,
                estimateOrderThisMonth: 0,
                successOrderThisMonth: 0,
                successOrderLastWeek: 0,
                successOrderThisWeek: 0,
                successOrderLastDay: 0,
                successOrderToday: 0,
                lastMonthAverageConversion: 0,
                averageConversionThisMonth: 0,
                averageConversionLastWeek: 0,
                averageConversionThisWeek: 0,
                averageConversionLastDay: 0,
                averageConversionToday: 0
            },

            topCards: [
                { title: '本月总请求量', value: '1200 (+10%)' },
                { title: '本月订单', value: '300 (+5%)' },
                { title: '日清货量', value: '50 (+3%)' },
                { title: '日订单', value: '15 (+2%)' },
                { title: '日转化率', value: '30% (+1%)' },
                { title: '上月订单', value: '280 (-3%)' },
                { title: '上周订单', value: '70 (+4%)' },
                { title: '昨日订单', value: '20 (-1%)' },
                { title: '本周订单', value: '90 (+6%)' },
                { title: '本日前订单', value: '10 (+2%)' }
            ]
        };
    },

    beforeDestroy() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
    },
    mounted() {
        this.calculateChartHeight();
        window.addEventListener('resize', this.calculateChartHeight);
        this.getOrderStatistics();
        // //自动刷新 todo 开发关闭
        this.startRefreshCountdown();
        // 自动滚动逻辑开始0
        this.$nextTick(() => {
            // this.startAutoScroll();
        });


    },
    computed: {},
    created() {

    },
    methods: {
        initChart(id, title, categories, data,color) {
            const chart = echarts.init(document.getElementById(id));
            const option = {
                title: {
                    text: title ,
                    textStyle: {
                        color: color,
                        fontSize: 14
                    },
                    right: 'right',
                    top: 'top',
                    fontStyle: 'italic',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '10%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: categories,
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLabel: {
                        rotate: 30, // 旋转角度
                        interval: 0, // 强制显示所有标签
                        fontSize: 10,
                        formatter: function(value) {

                            // 或者超出长度显示省略号
                            return value.length > 5 ? value.substring(0,5)+'...' : value;
                        }
                    }
                },
                yAxis: {
                    type: 'value',

                },
                series: [{
                    name: title,
                    type: 'bar',
                    color: color,
                    data: data
                }]
            };
            chart.setOption(option);
        }
        ,initChart3(id, title, categories, data) {
            const chart = echarts.init(document.getElementById(id));
            const option = {
                title: {
                    text: title ,
                    textStyle: {
                        color: 'rgba(128,142,230,0.84)',
                        fontSize: 14
                    },
                    right: 'right',
                    top: 'top',
                    fontStyle: 'italic',
                },
                tooltip: {
                    alwaysShowContent: true,
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: function(params) {
                        // 打印 params 以查看其结构
                        console.log(params);
                        // 获取 X 轴的值
                        const xAxisValue = params[0].axisValue;

                        // 构建提示框内容
                        return `${xAxisValue}<br/>` + params.map(item => {
                            return `${item.seriesName}: ${item.value}%`;
                        }).join('<br/>');
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '10%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: categories,
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLabel: {
                        rotate: 30, // 旋转角度
                        interval: 0, // 强制显示所有标签
                        fontSize: 10,
                        formatter: function(value) {

                            // 或者超出长度显示省略号
                            return value.length > 5 ? value.substring(0,5)+'...' : value;
                        }
                    }
                },
                yAxis: {
                    type: 'value',

                },
                series: [{
                    name: title,
                    type: 'bar',
                    color: 'rgb(19,122,222,0.8)',
                    data: data
                }]
            };
            chart.setOption(option);
        }
        ,
        initChart1(id, title, categories, data,dataTitle,data2,data2Title,color) {
            const chart = echarts.init(document.getElementById(id));
            const option = {
                title: {
                    text: title,
                    textStyle: {
                        color: 'rgba(128,142,230,0.84)',
                        fontSize: 14
                    },
                    right: 'right',
                    top: 'top',
                    fontStyle: 'italic',},
                tooltip: {
                    show: true,
                    trigger: 'axis'
                },
                legend: {
                    data: [dataTitle,data2Title]
                },
                xAxis: {
                    data: categories,
                    axisLabel: {
                        rotate: 30, // 旋转角度
                        interval: 0 // 强制显示所有标签
                    }
                },
                yAxis: {},
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '10%',
                    containLabel: true
                },
                series: [{
                    name: dataTitle,
                    type: 'line',
                    data: data,
                    color: '#bdd83f'
                },{
                    name: data2Title,
                    type: 'line',
                    data: data2,
                    color: color
                }
                ]
            };
            chart.setOption(option);
        }
        ,
        startRefreshCountdown() {
            if (this.refreshInterval) {
                clearInterval(this.refreshInterval);
            }

            this.refreshInterval = setInterval(() => {

                    console.log('页面即将刷新...');
                    // 请求完成后模拟点击事件，重置超时计时器
                    this.simulateClick();
                    this.getOrderStatistics(); // 刷新数据，不刷新页面

            },  1000 * 60 * 5);
        },


        formatProgress(percentage, item) {
            return `订购量：${item.success} | 转化率：${item.avg}% | 销售占比：${percentage}%`;
        },
        getOrderStatistics30(type) {
            console.log('type===>' + type);
            let query = {
                type: type
            };
            if (type.startsWith('channel')) {
                this.channelLoading = true;
            } else {
                this.productLoading = true;
            }
            dataStatistics30(query).then(res => {
                if (res.code == '200') {
                    if (type.startsWith('channel')) {

                        let option1Sum = res.data.channelOrderData.longs.reduce((total, current) => total + current, 0);
                        if (!option1Sum) {
                            option1Sum = 0;
                        }
                        this.option1.title.text = '近30天渠道销售图 总计(' + option1Sum + ') ';
                        this.option1.labels = res.data.channelOrderData.cnames;
                        this.option1.datasets[0].data = res.data.channelOrderData.longs;

                    } else {

                        this.option4 = res.data.products;
                        if (res.data.products) {
                            this.lastTotalAvg = res.data.products.reduce((sum, item) => sum + item.success, 0);
                        } else {
                            this.lastTotalAvg = 0;
                        }
                    }

                    this.channelLoading = false;
                    this.productLoading = false;
                    console.log('dataStatistics30接口返回=====>', res);
                }

            });

        },
        getIconClass(title) {
            const iconMap = {
                '今日订购量': 'el-icon-lx-roundcheckfill',
                '今日请求量': 'el-icon-lx-timefill',
                '今日转化率': 'el-icon-s-help',
                '本月订购量': 'el-icon-lx-roundcheckfill',
                '本月请求量': 'el-icon-lx-timefill',
                '累计订购量': 'el-icon-lx-roundcheckfill',
                '昨日订购量': 'el-icon-lx-roundcheckfill',
                '本周订购量': 'el-icon-lx-roundcheckfill',
                '上周订购量': 'el-icon-lx-roundcheckfill',
                '上月订购量': 'el-icon-lx-roundcheckfill',
                '前月订购量': 'el-icon-lx-roundcheckfill',
                '累计请求量': 'el-icon-lx-timefill'
            };
            return iconMap[title] || '';
        },
        simulateClick() {
            let item = localStorage.getItem("lastOperTime111");
            console.log('lastOperTime111===>',item)
            console.log('模拟点击事件出发',localStorage.getItem(window.location.hostname+'_phone'))
            if (localStorage.getItem(window.location.hostname+'_phone') === '18737669774'){
                console.log('模拟点击事件出发')
                const event = new MouseEvent('mousedown', {
                    bubbles: true,
                    cancelable: true,
                    view: window
                });
                document.dispatchEvent(event);
            }
        },
        calculateChartHeight() {
            // 根据屏幕高度或其他逻辑动态计算
            this.chartHeight = window.innerHeight * 0.18;
            console.log('chartHeight===>', this.chartHeight)
        },
        getOrderStatistics() {
            this.rowLoading = true;
            this.schartLoading = true; 
            findDataByDataBody5().then(res => {
                if (res.code == '200') {
                    console.log('findDataByDataBody5===>', res);

                    this.topCards = res.data;
                }
                this.rowLoading = false;
            });
            findEchartByDataBody5().then(res => {
                if (res.code == '200'){
                    let skinConfig = localStorage.getItem(window.location.hostname+'_cl_skinConfig');
                    var skinData = JSON.parse(skinConfig);
                    this.initChart('echart1', '日成功订单产品排名(产品)', res.data.no1X, res.data.no1Y,skinData.theme_bgcolor);
                    this.initChart('echart2', '日贡献渠道排名(下游)', res.data.no2X, res.data.no2Y,skinData.theme_bgcolor);
                    this.initChart('echart3', '日转化率排名(产品)',  res.data.no3X, res.data.no3Y,skinData.theme_bgcolor);
                    this.initChart('echart4', '月请求量排名(下游)', res.data.no4X, res.data.no4Y,skinData.theme_bgcolor);


                }
                this.schartLoading = false;
            })

            findDataByTodayAndThisMonth().then(res => {
                if (res.code == '200'){
                    let skinConfig = localStorage.getItem(window.location.hostname+'_cl_skinConfig');
                    var skinData = JSON.parse(skinConfig);
                    this.initChart1('echart5', '分时进单', res.data.xList,
                        res.data.successList,"成功订单",res.data.totalList,"总进单量",skinData.theme_bgcolor);
                    this.initChart1('echart6', '月进单', res.data.xDayList, res.data.successDayList
                        ,"成功订单",res.data.totalDayList,"总进单量",skinData.theme_bgcolor);
                } 
            })
        }
    }
};

</script>


<style scoped>
.dashboard {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    padding: 5px;
}
.chart-rows {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}

.card-container {
    position: relative;
    overflow: visible;
}

.top-card {
    height: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 5px 0;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.8);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
    z-index: 2;
    position: relative;
}
.card-title {
    font-size: 13px; 
    margin-top: 0; /* 移除顶部间距 */
    text-align: center; 
    color: rgba(50, 50, 50, 0.8);
}
.card-title2 {
    font-size: 13px; 
    margin-top: 0; /* 移除顶部间距 */
    text-align: center; 
    color: rgba(50, 50, 50, 0.8); 
}

.card-value {
    font-size: 20px;
    font-weight: bold; 
    margin-top: 5px;
    text-align: center; 
    color: var(--theme_bgcolor);
}
.card-value2 {
    font-size: 25px;
    font-weight: bold; 
    margin-top: 5px;
    text-align: center; 
    color: rgba(2, 174, 7, 0.8);
}

.el-col-4 {
    width: 16.6%;
}

.hover-layer {
    border-radius: 10px;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, #7ebcfd, #7ebcfd);
    transform: scale(0);
    transform-origin: center center;
    opacity: 0.6;
    transition: all 0.4s ease-in-out;
    z-index: 1;
    pointer-events: none;
}

.card-container:hover .hover-layer {
    transform: scale(1);
    opacity: 1;
}
.card-value span {
    font-weight: normal;
}

.card-value .positive {
    color: #2ecc71; /* 鲜亮绿色，表示增长 */
}

.card-value .negative {
    color: #e74c3c; /* 鲜艳红色，表示下降 */
}
.echartswh {
    width: 96%;
    padding:3% 2%;
    height: 100%; /* 自动继承父容器高度 */
    min-height: 140px; /* 最小高度兜底 */
    margin:10px 0 15px 0;
    border:1px solid #ddd;
     
}

.icon {
    font-size: 40px;
    height: 100px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    vertical-align: middle;
    position: absolute;
    left:20px;
    color:var(--theme_bgcolor);
    
}
.icon2 {
    font-size: 45px;
    height: 100px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px; 
    vertical-align: middle;
    color:var(--theme_bgcolor);

}
.card-content {
    display: flex;
    align-items: center;
    margin-left:20px;
}
.text-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center; /* 确保文本居中对齐 */
}
@media (max-width: 768px) {
    .el-col-4 {
        width: 50%; /* 手机端两列显示 */
        margin-bottom: 10px;
    }
}
@media (min-width: 769px) and (max-width: 1024px) {
    .el-col-4 {
        width: 33.33%; /* 平板三列显示 */
    }
}

.el-row {
    margin-bottom: 2px !important;
}
.mt5{
    margin-top:5px !important;
} 
 /*
.card-content{
        内联元素（inline）动画不起作用， 因此要设置为‘inline-block’  
        animation: jump2 2s infinite ease-in-out;
        animation-delay: var(--delay);
      }

      @keyframes jump2 { 
        100% {
          transform: translateY(0);
        }
        50% {
          transform: translateY(-10px);
        }
      } */

      .iconJump2 {
            color: #409EFF;
            background-image: -webkit-linear-gradient(90deg, #409EFF, #01ac25);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            -webkit-animation: change2 5s infinite linear;
        }
        @-webkit-keyframes change2 {
            from {
            -webkit-filter: hue-rotate(0deg);
            }
            to {
            -webkit-filter: hue-rotate(-360deg);
            }
        } 

</style>
